import React from "react";
import { useTranslation } from "react-i18next";
import "./scss/Register.scss";
import { Link } from "react-router-dom";

import loginBg from "../images/login/login-bg.png";

const Register = () => {
  const { t } = useTranslation();
  document.title = `Gudema - ${t("loginPage.register")}`;

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Register request submitted");
  };

  return (
    <main className="register-page">
      <section className="register-access">
        <div className="register-access__container">
          <div className="register-access__form-side">
            <div className="register-access__intro">
              <h1>{t("registerPage.title")}</h1>

              <p>{t("registerPage.subtitle")}</p>
            </div>

            <form className="register-form" onSubmit={handleSubmit}>
              <input type="text" placeholder={t("common.form.firstName")} required />
              <input type="text" placeholder={t("common.form.lastName")} required />
              <input type="email" placeholder={t("common.form.emailRequired")} required />
              <input type="tel" placeholder={t("common.form.phoneRequired")} required />
              <input type="text" placeholder={t("common.form.company")} />
              <textarea placeholder={t("common.form.messageRequired")} required />

              <label className="register-form__terms">
                <input type="checkbox" required />

                <span>
                  {t("common.form.termsStart")}{" "}
                  <Link to="/privacy" target="_blank" rel="noreferrer">
                    {t("common.form.termsServices")}
                  </Link>
                  .
                </span>
              </label>

              <div className="register-form__bottom">
                <button type="submit">{t("registerPage.submit")}</button>

                <p>{t("registerPage.bottomText")}</p>
              </div>
            </form>
          </div>

          <div className="register-access__image-side">
            <img src={loginBg} alt={t("registerPage.imageTitle")} />

            <div className="register-access__overlay">
              <h2>{t("registerPage.imageTitle")}</h2>

              <p>{t("registerPage.imageText")}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Register;
